'use client';

import { Box, Card, ProfileCardHeader } from 'src/components';
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons';
import { hasContent } from 'src/utils/hasContent/hasContent';
import EducationItem from 'src/modules/Profile/components/Views/components/EducationItem';
import { useProfile } from 'src/context/providers/ProfileProvider';

const ProfileEducationDetails = () => {
  const { entityDetails } = useProfile();

  const educationRecords = entityDetails?.education || [];

  return (
    <Card className="p-6 w-full h-full bg-white" data-testid="profile-education-details">
      <ProfileCardHeader icon={faGraduationCap} title="Education" />
      <Box role="list" aria-label="Education records" data-testid="education-list">
        {hasContent(educationRecords) ? (
          educationRecords.map((item, i) => {
            return <EducationItem key={`${item.id}-${i}`} item={item} />;
          })
        ) : (
          <div
            className="flex items-center justify-center h-full min-h-48"
            data-testid="education-details-empty"
          >
            <p className="text-sm font-semibold text-neutral-500">
              No data available
            </p>
          </div>
        )}
      </Box>
    </Card>
  );
};

export default ProfileEducationDetails;
